/*
 * @Author: ylq
 * @Date: 2022-09-19 15:35:08
 * @Desc: DESC
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-11-28 18:30:58
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
const DEFAULT_PAGE = () => import('@/layout/page.vue');

const SETTING = {
  path: '/setting',
  name: 'setting',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'setting-info' },
  meta: {
    title: '设置中心',
    requiresAuth: true,
    single: true,
    roles: 'settings',
    icon: 'icon-settings',
    order: 10
  },
  children: [
    {
      path: 'info',
      name: 'setting-info',
      component: DEFAULT_PAGE,
      redirect: { name: 'setting-info-home' },
      meta: {
        requiresAuth: true,
        icon: 'icon-home',
        roles: 'settings:home',
        title: '首页',
        hideChildrenInMenu: true
      },
      children: [
        {
          path: '',
          name: 'setting-info-home',
          component: () => import('@/views/setting/info/info.vue'),
          meta: {
            requiresAuth: true,
            title: '首页'
          }
        }
      ]
    },
    {
      path: 'org',
      name: 'setting-org',
      component: DEFAULT_PAGE,
      redirect: { name: 'setting-user' },
      meta: {
        requiresAuth: true,
        icon: 'icon-user-group',
        roles: 'settings',
        title: '组织权限'
      },
      children: [
        {
          path: 'user-list',
          name: 'setting-user',
          component: DEFAULT_PAGE,
          redirect: { name: 'setting-user-index' },
          meta: {
            hideChildrenInMenu: true,
            requiresAuth: true,
            roles: 'authority:user',
            title: '组织用户'
          },
          children: [
            {
              path: '',
              name: 'setting-user-index',
              // component: () => import('@/views/setting/user-list/user-list.vue'),
              component: () => import('@/views/setting/organization-member/organization-member.vue'),
              meta: {
                requiresAuth: true,
                title: '组织用户'
              }
            },
            {
              path: '',
              name: 'tripartite-record',
              component: () => import('@/views/setting/organization-member/tripartite-record/tripartite-record.vue'),
              meta: {
                requiresAuth: true,
                title: '三方同步记录'
              }
            },
            {
              path: 'resigned',
              name: 'setting-user-resigned',
              component: () => import('@/views/setting/user-list-resigned/user-list-resigned.vue'),
              meta: {
                requiresAuth: true,
                title: '已停用用户'
              }
            },
            {
              path: 'person',
              name: 'setting-resigned-person',
              component: () => import('@/views/setting/user-depart-person/user-depart-person.vue'),
              meta: {
                requiresAuth: true,
                title: '停用用户数据管理'
              }
            }
          ]
        },
        // {
        //   path: 'roles',
        //   name: 'setting-roles',
        //   component: () => import('@/views/setting/roles/roles.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     roles: 'authority:role-bak',
        //     title: '角色权限'
        //   }
        // },
        {
          path: 'roles',
          name: 'setting-roles-new',
          component: () => import('@/views/setting/roles-new/roles-new.vue'),
          meta: {
            requiresAuth: true,
            roles: 'authority:role',
            title: '角色权限'
          }
        }
      ]
    },
    {
      path: 'object',
      name: 'setting-object',
      component: DEFAULT_PAGE,
      redirect: { name: 'setting-sys-fields' },
      meta: {
        requiresAuth: true,
        icon: 'icon-storage',
        roles: 'settings',
        title: '对象管理'
      },
      children: [
        {
          path: 'sys-fields',
          name: 'setting-sys-fields',
          component: DEFAULT_PAGE,
          redirect: { name: 'setting-sys-fields-index' },
          meta: {
            hideChildrenInMenu: true,
            requiresAuth: true,
            roles: 'object:system',
            title: '系统对象'
          },
          children: [
            {
              path: 'index',
              name: 'setting-sys-fields-index',
              component: () => import('@/views/setting/sys-fields/sys-fields.vue'),
              meta: {
                requiresAuth: true,
                title: '系统对象'
              }
            },

            {
              path: ':id',
              name: 'setting-sys-fields-detail',
              component: () => import('@/layout/customObject.vue'),
              redirect: { name: 'setting-sys-fields-detail-set' },
              meta: {
                hideChildrenInMenu: true,
                requiresAuth: true,
                hasTabs: true, // 页面是否是tabs展示
                hasBreadcrumb: true, // 页面是否展示tabs的面包屑
                tabsFixed: 59, // tabs 是否需要固定，如果没有这个属性，则不固定
                title: ''
              },
              children: [
                {
                  path: 'basic',
                  name: 'setting-sys-fields-detail-basic',
                  component: () => import('@/views/setting/sys-fields/sys-fields-basic/sys-fields-basic.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '基本信息'
                  }
                },
                {
                  path: 'set',
                  name: 'setting-sys-fields-detail-set',
                  component: () => import('@/views/setting/sys-fields/sys-fields-detail/sys-fields-detail.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '字段设置'
                  }
                },
                {
                  path: 'view',
                  name: 'setting-sys-fields-detail-view',
                  component: DEFAULT_PAGE,
                  redirect: { name: 'setting-sys-fields-detail-view-list' },
                  meta: {
                    requiresAuth: true,
                    title: '视图设置'
                  },
                  children: [
                    {
                      path: '',
                      name: 'setting-sys-fields-detail-view-list',
                      component: () => import('@/views/setting/sys-fields/view/view.vue'),
                      meta: {
                        requiresAuth: true,
                        title: ''
                      }
                    },
                    {
                      path: 'add',
                      name: 'setting-sys-fields-detail-view-add',
                      component: () => import('@/views/setting/sys-fields/view-update/view-update.vue'),
                      meta: {
                        requiresAuth: true,
                        title: '创建视图'
                      }
                    },
                    {
                      path: 'edit:viewId',
                      name: 'setting-sys-fields-detail-view-edit',
                      component: () => import('@/views/setting/sys-fields/view-update/view-update.vue'),
                      meta: {
                        requiresAuth: true,
                        title: '编辑视图'
                      }
                    }
                  ]
                },
                {
                  path: 'layout',
                  name: 'setting-sys-fields-layout',
                  component: DEFAULT_PAGE,
                  redirect: { name: 'setting-sys-fields-layout-list' },
                  meta: {
                    requiresAuth: true,
                    title: '布局设置'
                  },
                  children: [
                    {
                      path: '',
                      name: 'setting-sys-fields-layout-list',
                      component: () => import('@/views/setting/sys-fields/page-layout/page-layout.vue'),
                      meta: {
                        requiresAuth: true,
                        title: ''
                      }
                    }
                  ]
                },
                // 查重路由
                {
                  path: 'repeat',
                  name: 'setting-sys-fields-detail-repeat',
                  component: () => import('@/views/setting/sys-fields/repeat/repeat.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '查重设置'
                  }
                },
                {
                  path: 'button',
                  name: 'setting-sys-fields-detail-button',
                  component: () => import('@/views/setting/sys-fields/sys-fields-button/sys-fields-button.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '按钮设置'
                  }
                },
                {
                  path: 'import',
                  name: 'setting-sys-fields-import',
                  component: DEFAULT_PAGE,
                  redirect: { name: 'setting-sys-import-list' },
                  meta: {
                    requiresAuth: true,
                    // roles: 'setting-obj-system',
                    title: '导入设置'
                  },
                  children: [
                    {
                      path: '',
                      name: 'setting-sys-import-list',
                      component: () => import('@/views/setting/import-settings/index.vue'),
                      meta: {
                        requiresAuth: true,
                        // roles: 'setting-obj-system',
                        title: ''
                      }
                    },
                    {
                      path: 'edit-import',
                      name: 'setting-sys-edit-import',
                      component: () => import('@/views/setting/import-settings/edit-import/index.vue'),
                      meta: {
                        requiresAuth: true,
                        // roles: 'setting-obj-system',
                        title: '编辑'
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: 'custom-object',
          name: 'setting-custom-object',
          component: DEFAULT_PAGE,
          redirect: { name: 'setting-custom-object-index' },
          meta: {
            hideChildrenInMenu: true,
            requiresAuth: true,
            roles: 'object:custom',
            title: '自定义对象'
          },
          children: [
            {
              path: 'index',
              name: 'setting-custom-object-index',
              component: () => import('@/views/setting/sys-fields/sys-fields.vue'),
              meta: {
                requiresAuth: true,
                title: '自定义对象'
              }
            },

            {
              path: ':id',
              name: 'setting-cus-fields-detail',
              component: () => import('@/layout/customObject.vue'),
              redirect: { name: 'setting-cus-fields-detail-set' },
              meta: {
                hideChildrenInMenu: true,
                requiresAuth: true,
                hasTabs: true, // 页面是否是tabs展示
                hasBreadcrumb: true, // 页面是否展示tabs的面包屑
                tabsFixed: 59, // tabs 是否需要固定，如果没有这个属性，则不固定
                title: ''
              },
              children: [
                {
                  path: 'basic',
                  name: 'setting-cus-fields-detail-basic',
                  component: () => import('@/views/setting/sys-fields/sys-fields-basic/sys-fields-basic.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '基本信息'
                  }
                },
                {
                  path: 'set',
                  name: 'setting-cus-fields-detail-set',
                  component: () => import('@/views/setting/sys-fields/sys-fields-detail/sys-fields-detail.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '字段设置'
                  }
                },
                {
                  path: 'view',
                  name: 'setting-cus-fields-detail-view',
                  component: DEFAULT_PAGE,
                  redirect: { name: 'setting-cus-fields-detail-view-list' },
                  meta: {
                    requiresAuth: true,
                    title: '视图设置'
                  },
                  children: [
                    {
                      path: '',
                      name: 'setting-cus-fields-detail-view-list',
                      component: () => import('@/views/setting/sys-fields/view/view.vue'),
                      meta: {
                        requiresAuth: true,
                        title: ''
                      }
                    },
                    {
                      path: 'add',
                      name: 'setting-cus-fields-detail-view-add',
                      component: () => import('@/views/setting/sys-fields/view-update/view-update.vue'),
                      meta: {
                        requiresAuth: true,
                        title: '创建视图'
                      }
                    },
                    {
                      path: 'edit:viewId',
                      name: 'setting-cus-fields-detail-view-edit',
                      component: () => import('@/views/setting/sys-fields/view-update/view-update.vue'),
                      meta: {
                        requiresAuth: true,
                        title: '编辑视图'
                      }
                    }
                  ]
                },
                {
                  path: 'layout',
                  name: 'setting-cus-fields-layout',
                  component: DEFAULT_PAGE,
                  redirect: { name: 'setting-cus-fields-layout-list' },
                  meta: {
                    requiresAuth: true,
                    title: '布局设置'
                  },
                  children: [
                    {
                      path: '',
                      name: 'setting-cus-fields-layout-list',
                      component: () => import('@/views/setting/sys-fields/page-layout/page-layout.vue'),
                      meta: {
                        requiresAuth: true,
                        title: ''
                      }
                    }
                  ]
                },
                // 查重路由
                {
                  path: 'repeat',
                  name: 'setting-cus-fields-detail-repeat',
                  component: () => import('@/views/setting/sys-fields/repeat/repeat.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '查重设置'
                  }
                },
                {
                  path: 'button',
                  name: 'setting-cus-fields-detail-button',
                  component: () => import('@/views/setting/sys-fields/sys-fields-button/sys-fields-button.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '按钮设置'
                  }
                },
                {
                  path: 'import',
                  name: 'setting-cus-fields-import',
                  component: DEFAULT_PAGE,
                  redirect: { name: 'setting-cus-import-list' },
                  meta: {
                    requiresAuth: true,
                    // roles: 'setting-obj-system',
                    title: '导入设置'
                  },
                  children: [
                    {
                      path: '',
                      name: 'setting-cus-import-list',
                      component: () => import('@/views/setting/import-settings/index.vue'),
                      meta: {
                        requiresAuth: true,
                        // roles: 'setting-obj-system',
                        title: ''
                      }
                    },
                    {
                      path: 'edit-import',
                      name: 'setting-cus-edit-import',
                      component: () => import('@/views/setting/import-settings/edit-import/index.vue'),
                      meta: {
                        requiresAuth: true,
                        // roles: 'setting-obj-system',
                        title: '编辑'
                      }
                    },
                    {
                      path: 'permissions',
                      name: 'setting-cus-fields-detail-permissions',
                      component: () => import('@/views/setting/sys-fields/sys-fields-permissions/sys-fields-permissions.vue'),
                      meta: {
                        requiresAuth: true,
                        title: '数据权限'
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },

        {
          path: 'global-fields',
          name: 'setting-global-fields',
          component: () => import('@/views/setting/global-fields/global-fields.vue'),
          meta: {
            requiresAuth: true,
            roles: 'object:global',
            title: '全局字段'
          }
        },
        {
          path: 'authority',
          name: 'setting-object-authority',
          component: () => import('@/views/setting/object-authority/object-authority.vue'),
          meta: {
            requiresAuth: true,
            roles: 'object:dataPermission',
            title: '数据权限管理'
          }
        },
        {
          path: 'lead-pool',
          name: 'setting-lead-pool',
          redirect: { name: 'setting-lead-pool-list' },
          component: () => import('@/layout/pageTabs.vue'),
          meta: {
            requiresAuth: true,
            hideChildrenInMenu: true,
            hasTabs: true,
            tabsFixed: 48,
            roles: 'object:cluePool',
            title: '线索池管理'
          },
          children: [
            {
              path: 'record',
              name: 'setting-lead-pool-record',
              redirect: { name: 'setting-lead-pool-list' },
              component: DEFAULT_PAGE,
              meta: {
                requiresAuth: true,
                title: '线索池设置'
              },
              children: [
                {
                  path: '',
                  name: 'setting-lead-pool-list',
                  component: () => import('@/views/setting/lead-pool/lead-pool.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '线索池列表'
                  }
                },
                {
                  path: 'add',
                  name: 'setting-lead-pool-add',
                  component: () => import('@/views/setting/lead-pool/lead-pool-update/lead-pool-update.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '新增线索池'
                  }
                },
                {
                  path: 'update:id',
                  name: 'setting-lead-pool-edit',
                  component: () => import('@/views/setting/lead-pool/lead-pool-update/lead-pool-update.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '编辑线索池'
                  }
                }
              ]
            },
            {
              path: 'inventory',
              name: 'setting-lead-pool-inventory',
              component: () => import('@/views/setting/lead-pool/lead-pool-inventory/lead-pool-inventory.vue'),
              meta: {
                requiresAuth: true,
                title: '保有量设置'
              }
            },
            {
              path: 'layout',
              name: 'setting-lead-pool-layout',
              component: () => import('@/views/setting/sys-fields/page-layout/page-layout.vue'),
              meta: {
                requiresAuth: true,
                title: '布局设置'
              }
            },
            {
              path: 'buttons',
              name: 'setting-lead-pool-buttons',
              component: () => import('@/views/setting/sys-fields/sys-fields-button/sys-fields-button.vue'),
              meta: {
                requiresAuth: true,
                title: '按钮设置'
              }
            },
            {
              path: 'lead-pool-import',
              name: 'setting-lead-pool-import',
              component: DEFAULT_PAGE,
              redirect: { name: 'setting-lead-pool-import-list' },
              meta: {
                requiresAuth: true,
                // roles: 'setting-obj-system',
                title: '导入设置'
              },
              children: [
                {
                  path: '',
                  name: 'setting-lead-pool-import-list',
                  component: () => import('@/views/setting/import-settings/index.vue'),
                  meta: {
                    requiresAuth: true,
                    // roles: 'setting-obj-system',
                    title: ''
                  }
                },
                {
                  path: 'edit-import',
                  name: 'setting-lead-pool-import-edit',
                  component: () => import('@/views/setting/import-settings/edit-import/index.vue'),
                  meta: {
                    requiresAuth: true,
                    // roles: 'setting-obj-system',
                    title: '编辑'
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: 'rule',
      name: 'setting-rule',
      component: DEFAULT_PAGE,
      redirect: { name: 'setting-rule-manage' },
      meta: {
        requiresAuth: true,
        icon: 'icon-mind-mapping',
        roles: 'settings',
        title: '规则管理'
      },
      children: [
        {
          path: 'manage',
          name: 'setting-rule-manage',
          component: DEFAULT_PAGE,
          redirect: { name: 'setting-rule-manage-index' },
          meta: {
            hideChildrenInMenu: true,
            requiresAuth: true,
            roles: 'ruleManagement:object',
            title: '对象映射规则'
          },
          children: [
            {
              path: '',
              name: 'setting-rule-manage-index',
              component: () => import('@/views/setting/rule-manage/rule-manage.vue'),
              meta: {
                requiresAuth: true,
                title: '对象映射规则设置'
              }
            },
            {
              path: 'edit:id',
              name: 'setting-rule-manage-edit',
              component: () => import('@/views/setting/rule-manage-detail/rule-manage-detail.vue'),
              meta: {
                requiresAuth: true,
                title: '对象映射规则详情'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'plugin',
      name: 'setting-plugin',
      component: DEFAULT_PAGE,
      redirect: { name: 'setting-plugin-call' },
      meta: {
        icon: 'icon-tool',
        requiresAuth: true,
        roles: 'settings',
        title: '业务插件管理'
      },
      children: [
        {
          path: 'e-sign',
          name: 'setting-plugin-e-sign',
          component: DEFAULT_PAGE,
          redirect: { name: 'setting-plugin-sign-index' },
          meta: {
            hideChildrenInMenu: true,
            requiresAuth: true,
            hideInMenu: true,
            roles: 'businessPlugin:eQianBao',
            title: 'e签宝电子签章'
          },
          children: [
            {
              path: '',
              name: 'setting-plugin-sign-index',
              component: () => import('@/views/setting/e-sign/e-sign.vue'),
              meta: {
                requiresAuth: true,
                title: '合同模板'
              }
            },
            {
              path: 'detail:id-:type',
              name: 'setting-plugin-sign-detail',
              component: () => import('@/views/setting/e-sign/e-sign-field/e-sign-field.vue'),
              meta: {
                requiresAuth: true,
                title: '字段设置'
              }
            },
            {
              path: 'add',
              name: 'setting-fields-mapping-add',
              component: () => import('@/views/setting/e-sign/components/fields-mapping-detail/fields-mapping-detail.vue'),
              meta: {
                requiresAuth: true,
                title: '添加字段映射规则'
              }
            },
            {
              path: 'edit:id',
              name: 'setting-fields-mapping-edit',
              component: () => import('@/views/setting/e-sign/components/fields-mapping-detail/fields-mapping-detail.vue'),
              meta: {
                requiresAuth: true,
                title: '编辑字段映射规则'
              }
            },
            {
              path: 'sign',
              name: 'add-signing-add',
              component: () => import('@/views/setting/e-sign/components/add-signing/add-signing.vue'),
              meta: {
                requiresAuth: true,
                title: '新建签约设置'
              }
            },
            {
              path: 'sign:id',
              name: 'add-signing-edit',
              component: () => import('@/views/setting/e-sign/components/add-signing/add-signing.vue'),
              meta: {
                requiresAuth: true,
                title: '编辑签约设置'
              }
            }
          ]
        },
        // {
        //   path: 'call',
        //   name: 'setting-plugin-call',
        //   component: () => import('@/layout/pageTabs.vue'),
        //   redirect: { name: 'setting-plugin-call-user' },
        //   meta: {
        //     requiresAuth: true,
        //     hideChildrenInMenu: true,
        //     hasTabs: true, // 页面是否是tabs展示
        //     tabsFixed: 59, // tabs 是否需要固定，如果没有这个属性，则不固定
        //     roles: 'businessPlugin:RLOutbound',
        //     title: '容联外呼人员'
        //   },
        //   children: [
        //     {
        //       path: 'user',
        //       name: 'setting-plugin-call-user',
        //       component: () => import('@/views/setting/call-user/call-user.vue'),
        //       meta: {
        //         requiresAuth: true,
        //         title: '容联外呼人员管理'
        //       }
        //     },
        //     {
        //       path: 'telephone',
        //       name: 'setting-plugin-call-telephone',
        //       component: () => import('@/views/setting/call-telephone/call-telephone.vue'),
        //       meta: {
        //         requiresAuth: true,
        //         title: '容联外呼中间号'
        //       }
        //     }
        //   ]
        // },
        // {
        //   path: 'volcano',
        //   name: 'setting-plugin-volcano',
        //   component: () => import('@/views/setting/out-call-user/out-call-user.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     roles: 'businessPlugin:HSOutbound',
        //     title: '火山外呼人员管理'
        //   }
        // },
        // {
        //   path: 'pool',
        //   name: 'setting-plugin-pool',
        //   component: DEFAULT_PAGE,
        //   redirect: { name: 'setting-plugin-call-pool' },
        //   meta: {
        //     requiresAuth: true,
        //     hideChildrenInMenu: true,
        //     roles: 'businessPlugin:HSOutboundPool',
        //     title: '火山外呼池管理'
        //   },
        //   children: [
        //     {
        //       path: '',
        //       name: 'setting-plugin-call-pool',
        //       component: () => import('@/views/setting/out-call-pool/out-call-pool.vue'),
        //       meta: {
        //         requiresAuth: true,
        //         roles: 'businessPlugin:HSOutboundPool',
        //         title: '外呼池管理'
        //       }
        //     },
        //     {
        //       path: ':id',
        //       name: 'setting-plugin-call-pool-detail',
        //       component: () => import('@/views/setting/out-call-pool-detail/out-call-pool-detail.vue'),
        //       meta: {
        //         requiresAuth: true,
        //         roles: 'businessPlugin:HSOutboundPool',
        //         title: '外呼号码管理'
        //       }
        //     }
        //   ]
        // },
        {
          path: 'fs-contract',
          name: 'setting-plugin-fs-contract',
          component: DEFAULT_PAGE,
          props: { contractType: 1 },
          redirect: { name: 'setting-plugin-contract-index' },
          meta: {
            hideChildrenInMenu: true,
            requiresAuth: true,
            roles: 'businessPlugin:contract',
            title: '飞书合同'
          },
          children: [
            {
              path: '',
              name: 'setting-plugin-contract-index',
              component: () => import('@/views/setting/fei-shu-contract/fei-shu-contract.vue'),
              meta: {
                requiresAuth: true,
                title: '合同模板'
              }
            },
            {
              path: 'detail:id-:type',
              name: 'setting-plugin-contract-detail',
              component: () => import('@/views/setting/fei-shu-contract/contract-detail/contract-detail.vue'),
              props: { contractType: 1 },
              meta: {
                requiresAuth: true,
                title: '飞书合同'
              }
            },
            {
              path: 'add',
              name: 'setting-contract-mapping-add',
              component: () => import('@/views/setting/fei-shu-contract/mapping-rule-detail/mapping-rule-detail.vue'),
              props: { contractType: 1 },
              meta: {
                requiresAuth: true,
                title: '新建'
              }
            },
            {
              path: 'edit:id/copy:copy',
              name: 'setting-contract-mapping-edit',
              component: () => import('@/views/setting/fei-shu-contract/mapping-rule-detail/mapping-rule-detail.vue'),
              props: { contractType: 1 },
              meta: {
                requiresAuth: true,
                title: '编辑'
              }
            },
            {
              path: 'sign',
              name: 'add-signing-add',
              component: () => import('@/views/setting/e-sign/components/add-signing/add-signing.vue'),
              meta: {
                requiresAuth: true,
                title: '新建签约设置'
              }
            },
            {
              path: 'sign:id',
              name: 'add-signing-edit',
              component: () => import('@/views/setting/e-sign/components/add-signing/add-signing.vue'),
              meta: {
                requiresAuth: true,
                title: '编辑签约设置'
              }
            }
          ]
        },
        {
          path: 'zs-contract',
          name: 'setting-plugin-zs-contract',
          component: DEFAULT_PAGE,
          props: { contractType: 2 },
          redirect: { name: 'setting-plugin-zhishu-contract-index' },
          meta: {
            hideChildrenInMenu: true,
            requiresAuth: true,
            roles: 'businessPlugin:ZhiShuContract',
            title: '智书合同'
          },
          children: [
            {
              path: '',
              name: 'setting-plugin-zhishu-contract-index',
              component: () => import('@/views/setting/fei-shu-contract/fei-shu-contract.vue'),
              meta: {
                requiresAuth: true,
                title: '合同模板'
              }
            },
            {
              path: 'detail:id-:type',
              name: 'setting-plugin-zhishu-contract-detail',
              component: () => import('@/views/setting/fei-shu-contract/contract-detail/contract-detail.vue'),
              props: { contractType: 2 },
              meta: {
                requiresAuth: true,
                title: '智书合同'
              }
            },
            {
              path: 'add',
              name: 'setting-contract-zhishu-mapping-add',
              component: () => import('@/views/setting/fei-shu-contract/mapping-rule-detail/mapping-rule-detail.vue'),
              props: { contractType: 2 },
              meta: {
                requiresAuth: true,
                title: '新建'
              }
            },
            {
              path: 'edit:id/copy:copy',
              name: 'setting-contract-zhishu-mapping-edit',
              component: () => import('@/views/setting/fei-shu-contract/mapping-rule-detail/mapping-rule-detail.vue'),
              props: { contractType: 2 },
              meta: {
                requiresAuth: true,
                title: '编辑'
              }
            },
            {
              path: 'sign',
              name: 'add-signing-add',
              component: () => import('@/views/setting/e-sign/components/add-signing/add-signing.vue'),
              meta: {
                requiresAuth: true,
                title: '新建签约设置'
              }
            },
            {
              path: 'sign:id',
              name: 'add-signing-edit',
              component: () => import('@/views/setting/e-sign/components/add-signing/add-signing.vue'),
              meta: {
                requiresAuth: true,
                title: '编辑签约设置'
              }
            }
          ]
        },
        {
          path: 'connector',
          name: 'setting-connector',
          component: DEFAULT_PAGE,
          redirect: { name: 'setting-connector-index' },
          meta: {
            hideChildrenInMenu: true,
            requiresAuth: true,
            roles: 'businessPlugin:connect',
            title: '多维表格数据同步'
          },
          children: [
            {
              path: '',
              name: 'setting-connector-index',
              component: () => import('@/views/setting/connector/connector.vue'),
              meta: {
                requiresAuth: true,
                title: '多维表格数据同步'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'approve',
      name: 'setting-approve',
      component: DEFAULT_PAGE,
      redirect: { name: 'fh-setting-approve-setting' },
      meta: {
        requiresAuth: true,
        icon: 'qf-icon-approve',
        roles: 'settings',
        title: '审批管理',
        hideChildrenInMenu: false
      },
      children: [
        {
          path: 'fhset',
          name: 'fh-approve-setting',
          component: DEFAULT_PAGE,
          redirect: { name: 'fh-setting-approve-setting' },
          meta: {
            requiresAuth: true,
            title: '审批设置',
            roles: 'approveManage:settings',
            hideChildrenInMenu: true
          },
          children: [
            {
              path: '',
              name: 'fh-setting-approve-setting',
              component: () => import('@/views/setting/approve-manage/fh-approve-setting/fh-approve-setting.vue'),
              meta: {
                requiresAuth: true,
                title: '审批设置'
              }
            }
          ]
        },
        // {
        //   path: 'fh',
        //   name: 'fh-setting-approve-index',
        //   component: DEFAULT_PAGE,
        //   redirect: { name: 'fh-setting-approve-list' },
        //   meta: {
        //     requiresAuth: true,
        //     title: '烽火审批流程',
        //     roles: 'approveManage:fhmanager',
        //     hideChildrenInMenu: true
        //   },
        //   children: [
        //     {
        //       path: '',
        //       name: 'fh-setting-approve-list',
        //       component: () => import('@/views/setting/approve-manage/fh-approve/fh-approve-manage.vue'),
        //       meta: {
        //         requiresAuth: true,
        //         title: '烽火审批流程'
        //       }
        //     },
        //     {
        //       path: 'fh-add',
        //       name: 'fh-setting-approve-add',
        //       component: () => import('@/views/setting/approve-manage/fh-approve/fh-approve-add/fh-approve-add.vue'),
        //       meta: {
        //         requiresAuth: true,
        //         title: '新增审批流程'
        //       }
        //     },
        //     {
        //       path: 'fh-edit:id',
        //       name: 'fh-setting-approve-edit',
        //       component: () => import('@/views/setting/approve-manage/fh-approve/fh-approve-add/fh-approve-add.vue'),
        //       meta: {
        //         requiresAuth: true,
        //         title: '编辑审批流程'
        //       }
        //     }
        //   ]
        // },
        {
          path: '',
          name: 'fs-setting-approve',
          redirect: { name: 'setting-approve-index-list' },
          component: () => import('@/layout/pageTabs.vue'),
          meta: {
            requiresAuth: true,
            title: '飞书审批管理',
            hasTabs: true,
            tabsFixed: 48,
            roles: 'approveManage:approveManage',
            hideChildrenInMenu: true
          },
          children: [
            {
              path: 'fs-approve',
              name: 'setting-approve-index',
              redirect: { name: 'setting-approve-index-list' },
              component: DEFAULT_PAGE,
              meta: {
                requiresAuth: true,
                title: '审批流程'
              },
              children: [
                {
                  path: '',
                  name: 'setting-approve-index-list',
                  component: () => import('@/views/setting/approve-manage/fs-approve/fs-approve-manage.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '审批流程'
                  }
                },
                {
                  path: 'fs-add',
                  name: 'fs-setting-approve-add',
                  component: () => import('@/views/setting/approve-manage/fs-approve/fs-approve-add/fs-approve-add.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '新建审批流程'
                  }
                },
                {
                  path: 'fs-edit-:id-:copy',
                  name: 'fs-setting-approve-edit',
                  component: () => import('@/views/setting/approve-manage/fs-approve/fs-approve-add/fs-approve-add.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '编辑审批流程'
                  }
                }
              ]
            },
            {
              path: 'fs-sync-rules',
              name: 'setting-approve-async-rules-index',
              redirect: { name: 'setting-approve-async-index-list' },
              component: DEFAULT_PAGE,
              meta: {
                requiresAuth: true,
                title: '审批同步规则'
              },
              children: [
                {
                  path: '',
                  name: 'setting-approve-async-index-list',
                  component: () => import('@/views/setting/approve-manage/approve-sync-rule/index.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '审批同步规则'
                  }
                },
                {
                  path: 'async-add',
                  name: 'fs-setting-async-add',
                  component: () => import('@/views/setting/approve-manage/approve-sync-rule/update-sync-rule/index.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '新建同步规则'
                  }
                },
                {
                  path: 'async-edit-:id',
                  name: 'fs-setting-async-edit',
                  component: () => import('@/views/setting/approve-manage/approve-sync-rule/update-sync-rule/index.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '编辑同步规则'
                  }
                }
              ]
            },
            {
              path: 'external-object',
              name: 'setting-external-object',
              component: DEFAULT_PAGE,
              redirect: { name: 'setting-external-object-index' },
              meta: {
                hideChildrenInMenu: true,
                requiresAuth: true,
                roles: 'object:without',
                title: '审批模板'
              },
              children: [
                {
                  path: '',
                  name: 'setting-external-object-index',
                  component: () => import('@/views/setting/approve-manage/external-object/external-object.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '外部对象'
                  }
                },
                {
                  path: 'detail:id-:type',
                  name: 'setting-external-object-detail',
                  component: () => import('@/views/setting/approve-manage/external-object-detail/external-object-detail.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '对象下字段'
                  }
                }
              ]
            },
            {
              path: 'rule-api',
              name: 'setting-rule-api',
              component: DEFAULT_PAGE,
              redirect: { name: 'setting-rule-api-index' },
              meta: {
                hideChildrenInMenu: true,
                requiresAuth: true,
                roles: 'ruleManagement:interface',
                title: '映射规则'
              },
              children: [
                {
                  path: '',
                  name: 'setting-rule-api-index',
                  component: () => import('@/views/setting/approve-manage/rule-api/rule-api.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '接口映射规则设置'
                  }
                },
                {
                  path: 'add',
                  name: 'setting-rule-api-add',
                  component: () => import('@/views/setting/approve-manage/rule-api-detail/rule-api-detail.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '添加接口映射规则'
                  }
                },
                {
                  path: 'edit:id',
                  name: 'setting-rule-api-edit',
                  component: () => import('@/views/setting/approve-manage/rule-api-detail/rule-api-detail.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '编辑接口映射规则'
                  }
                }
              ]
            },
            {
              path: 'fs-data-source-ref',
              name: 'setting-approve-data-source',
              component: DEFAULT_PAGE,
              redirect: { name: 'setting-approve-data-source-list' },
              meta: {
                requiresAuth: true,
                title: '数据源引用'
              },
              children: [
                {
                  path: '',
                  name: 'setting-approve-data-source-list',
                  component: () => import('@/views/setting/approve-manage/approve-data-source/index.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '数据源引用'
                  }
                },
                {
                  path: 'data-source-add',
                  name: 'fs-setting-data-source-add',
                  component: () => import('@/views/setting/approve-manage/approve-data-source/update-data-source/index.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '新建任务'
                  }
                },
                {
                  path: 'data-source-edit-:id',
                  name: 'fs-setting-data-source-edit',
                  component: () => import('@/views/setting/approve-manage/approve-data-source/update-data-source/index.vue'),
                  meta: {
                    requiresAuth: true,
                    title: '编辑任务'
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: 'interface',
      name: 'setting-interface',
      component: DEFAULT_PAGE,
      redirect: { name: 'setting-interface-menu' },
      meta: {
        requiresAuth: true,
        icon: 'qf-icon-menu-interface',
        roles: 'settings',
        title: '界面管理',
        hideChildrenInMenu: false
      },
      children: [
        {
          path: '',
          name: 'setting-interface-menu',
          component: () => import('@/views/setting/interface/interface.vue'),
          meta: {
            requiresAuth: true,
            roles: 'pageManage:menuPage',
            title: '菜单界面管理'
          }
        },
        {
          path: 'option',
          name: 'setting-interface-option',
          component: DEFAULT_PAGE,
          redirect: { name: 'setting-interface-option-list' },
          meta: {
            requiresAuth: true,
            title: '菜单项管理',
            hideChildrenInMenu: true,
            roles: 'pageManage:options',
            hasBreadcrumb: true
          },
          children: [
            {
              path: '',
              name: 'setting-interface-option-list',
              component: () => import('@/views/setting/interface/menu-option/menu-option.vue'),
              meta: {
                requiresAuth: true,
                roles: 'option',
                title: '菜单项管理'
              }
            },
            {
              path: 'add',
              name: 'setting-interface-option-add',
              component: () => import('@/views/setting/interface/menu-option/menu-option-update/menu-option-update.vue'),
              meta: {
                requiresAuth: true,
                title: '新增菜单项'
              }
            },
            {
              path: 'edit:id',
              name: 'setting-interface-option-edit',
              component: () => import('@/views/setting/interface/menu-option/menu-option-update/menu-option-update.vue'),
              meta: {
                requiresAuth: true,
                title: '编辑菜单项'
              }
            }
          ]
        },
        {
          path: 'custom',
          name: 'setting-interface-custom',
          component: () => import('@/views/setting/interface/custom/custom.vue'),
          meta: {
            requiresAuth: true,
            roles: 'pageManage:customPage',
            title: '自定义页面管理'
          }
        }
      ]
    },
    // {
    //   path: 'flow',
    //   name: 'setting-flow',
    //   component: DEFAULT_PAGE,
    //   redirect: { name: 'setting-flow-manage' },
    //   meta: {
    //     requiresAuth: true,
    //     icon: 'icon-branch',
    //     roles: 'settings',
    //     title: '流程管理'
    //   },
    //   children: [
    //     {
    //       path: 'stage',
    //       name: 'setting-flow-stage',
    //       component: DEFAULT_PAGE,
    //       redirect: { name: 'setting-flow-stage-index' },
    //       meta: {
    //         hideChildrenInMenu: true,
    //         requiresAuth: true,
    //         roles: 'stageProcess:setting',
    //         title: '阶段流程设置'
    //       },
    //       children: [
    //         {
    //           path: '',
    //           name: 'setting-flow-stage-index',
    //           component: () => import('@/views/setting/opportunity-stage/opportunity-stage.vue'),
    //           meta: {
    //             requiresAuth: true,
    //             title: '阶段流程设置'
    //           }
    //         },
    //         {
    //           path: 'edit:id',
    //           name: 'setting-flow-stage-edit',
    //           component: () => import('@/views/setting/opportunity-stage-detail/opportunity-stage-detail.vue'),
    //           meta: {
    //             requiresAuth: true,
    //             title: '商机阶段详情'
    //           }
    //         },
    //         {
    //           path: 'edit:id/config',
    //           name: 'setting-flow-stage-config',
    //           component: () => import('@/views/setting/opportunity-stage-config/opportunity-stage-config.vue'),
    //           meta: {
    //             requiresAuth: true,
    //             title: '商机阶段详情配置'
    //           }
    //         }
    //       ]
    //     }
    //   ]
    // },
    {
      path: 'flow-new',
      name: 'setting-flow-new',
      component: DEFAULT_PAGE,
      redirect: { name: 'setting-flow-manage-new' },
      meta: {
        requiresAuth: true,
        icon: 'icon-branch',
        roles: 'settings',
        title: '流程推进器'
      },
      children: [
        {
          path: 'stage',
          name: 'setting-flow-stage-new',
          component: DEFAULT_PAGE,
          redirect: { name: 'setting-flow-stage-new-index' },
          meta: {
            hideChildrenInMenu: true,
            requiresAuth: true,
            roles: 'processPropeller:settings',
            title: '流程推进器设置'
          },
          children: [
            {
              path: '',
              name: 'setting-flow-stage-new-index',
              component: () => import('@/views/setting/flow-stage/flow-stage.vue'),
              meta: {
                requiresAuth: true,
                title: '流程推进器设置'
              }
            },
            // {
            //   path: 'add',
            //   name: 'setting-flow-stage-new-add',
            //   component: () => import('@/views/setting/flow-stage/components/update-flow/update-flow.vue'),
            //   meta: {
            //     requiresAuth: true,
            //     title: '新增流程推进器'
            //   }
            // },
            {
              path: 'update:id',
              name: 'setting-flow-stage-new-update',
              component: () => import('@/views/setting/flow-stage/components/update-flow/update-flow.vue'),
              meta: {
                requiresAuth: true,
                title: '编辑流程推进器'
              }
            }
          ]
        }
      ]
    },
    // {
    //   path: 'cost',
    //   name: 'setting-cost-center',
    //   component: DEFAULT_PAGE,
    //   redirect: { name: 'setting-cost-stage' },
    //   meta: {
    //     requiresAuth: true,
    //     icon: 'qf-icon-volcano-voice',
    //     roles: 'settings',
    //     title: '火山语音费用'
    //   },
    //   children: [
    //     {
    //       path: 'stage',
    //       name: 'setting-cost-stage',
    //       component: () => import('@/views/setting/cost-center/cost-center.vue'),
    //       meta: {
    //         requiresAuth: true,
    //         roles: 'HSCall:amount',
    //         title: '费用概览'
    //       }
    //     },
    //     {
    //       path: 'billing',
    //       name: 'setting-billing-details',
    //       redirect: { name: 'setting-billing-details-record' },
    //       component: () => import('@/layout/pageTabs.vue'),
    //       meta: {
    //         requiresAuth: true,
    //         hideChildrenInMenu: true,
    //         hasTabs: true,
    //         tabsFixed: 48,
    //         roles: 'HSCall:charging',
    //         title: '账单明细'
    //       },
    //       children: [
    //         {
    //           path: 'record',
    //           name: 'setting-billing-details-record',
    //           component: () => import('@/views/setting/cost-center/call-record/call-record.vue'),
    //           meta: {
    //             requiresAuth: true,
    //             title: '火山通话记录'
    //           }
    //         },
    //         {
    //           path: 'rent',
    //           name: 'setting-monthly-rent',
    //           component: () => import('@/views/setting/cost-center/monthly-rent/monthly-rent.vue'),
    //           meta: {
    //             requiresAuth: true,
    //             title: '火山号码月租'
    //           }
    //         }
    //       ]
    //     }
    //   ]
    // },
    {
      path: 'automated',
      name: 'setting-automated',
      component: DEFAULT_PAGE,
      redirect: { name: 'setting-automated-engine' },
      meta: {
        requiresAuth: true,
        icon: 'Zidonghuaguanli',
        roles: 'auto:process',
        title: '自动化管理'
      },
      children: [
        {
          path: 'engine',
          name: 'setting-automated-engine',
          redirect: { name: 'setting-automated-engine-list' },
          component: DEFAULT_PAGE,
          meta: {
            requiresAuth: true,
            hideChildrenInMenu: true,
            title: '自动化流程'
          },
          children: [
            {
              path: '',
              name: 'setting-automated-engine-list',
              component: () => import('@/views/setting/automation-engine/automation-engine.vue'),
              meta: {
                requiresAuth: true,
                title: '自动化流程'
              }
            },
            {
              path: 'add-:type',
              name: 'addFlow',
              component: () => import('@/views/setting/automation-engine/update-automation-flow/update-automation-flow.vue'),
              meta: {
                requiresAuth: true,
                title: '新建流程引擎',
                hideInMenu: true
              }
            },
            {
              path: 'update-:type-:id',
              name: 'updateFlow',
              component: () => import('@/views/setting/automation-engine/update-automation-flow/update-automation-flow.vue'),
              meta: {
                requiresAuth: true,
                title: '编辑流程引擎',
                hideInMenu: true
              }
            },
            {
              path: 'copy-:type-:id',
              name: 'copyFlow',
              component: () => import('@/views/setting/automation-engine/update-automation-flow/update-automation-flow.vue'),
              meta: {
                requiresAuth: true,
                title: '复制流程引擎',
                hideInMenu: true
              }
            },
            {
              path: 'process-log-:id',
              name: 'processLog',
              component: () => import('@/views/setting/automation-engine/process-log/process-log.vue'),
              meta: {
                requiresAuth: true,
                title: '操作日志',
                hideInMenu: true
              }
            }
          ]
        }
      ]
    },
    {
      path: 'operationlog',
      name: 'setting-operationlog',
      component: DEFAULT_PAGE,
      redirect: { name: 'setting-operationlog-logon' },
      meta: {
        requiresAuth: true,
        icon: 'qf-icon-log',
        roles: 'settings',
        title: '日志'
      },
      children: [
        {
          path: 'operationlog',
          name: 'setting-operationlog-logon',
          component: () => import('@/views/setting/operationlog-logon/operationlog-logon.vue'),
          meta: {
            requiresAuth: true,
            roles: 'operationLog:login',
            title: '登录日志'
          }
        },
        {
          path: 'applicationlog',
          name: 'setting-operationlog-application',
          component: () => import('@/views/setting/operationlog-application/operationlog-application.vue'),
          meta: {
            requiresAuth: true,
            roles: 'operationLog:application',
            title: '应用日志'
          }
        },
        {
          path: 'organizeuserlogs',
          name: 'setting-operationlog-organizeuserlogs',
          component: () => import('@/views/setting/operationlog-organizeuserlogs/operationlog-organizeuserlogs.vue'),
          meta: {
            requiresAuth: true,
            roles: 'operationLog:userOrg',
            title: '组织用户日志'
          }
        }
      ]
    }
  ]
};

export default SETTING;
